(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("leaflet"), require("jquery"), require("numeric"));
	else if(typeof define === 'function' && define.amd)
		define(["leaflet", "jquery", "numeric"], factory);
	else if(typeof exports === 'object')
		exports["leaflet-distortable-video"] = factory(require("leaflet"), require("jquery"), require("numeric"));
	else
		root["leaflet-distortable-video"] = factory(root["L"], root["jQuery"], root["numeric"]);
})(self, (__WEBPACK_EXTERNAL_MODULE_leaflet__, __WEBPACK_EXTERNAL_MODULE_jquery__, __WEBPACK_EXTERNAL_MODULE_numeric__) => {
return 